// src/constants/holderTypes.js

export const HOLDER_TYPES = {
    STORE: "STORE",
    STAFF: "STAFF",
    TECHNICIAN: "TECHNICIAN",
    EMPLOYEE: "EMPLOYEE",
    SITE: "SITE",
    VENDOR: "VENDOR",
    CLIENT: "CLIENT",
    WAREHOUSE: "WAREHOUSE",
    SCRAP: "SCRAP"
};

/**
 * Possible ID fields by holder type
 * Enterprise-safe fallback support
 */
export const HOLDER_ID_FIELDS = {

    [HOLDER_TYPES.STAFF]: [
        "uid",
        "user_id",
        "employee_id",
        "staff_id",
        "id"
    ],

    [HOLDER_TYPES.TECHNICIAN]: [
        "uid",
        "tech_id",
        "employee_id",
        "user_id",
        "id"
    ],

    [HOLDER_TYPES.EMPLOYEE]: [
        "uid",
        "employee_id",
        "user_id",
        "id"
    ],

    [HOLDER_TYPES.STORE]: [
        "store_id",
        "id",
        "uid"
    ],

    [HOLDER_TYPES.SITE]: [
        "site_id",
        "project_id",
        "id"
    ],

    [HOLDER_TYPES.CLIENT]: [
        "client_id",
        "id"
    ],

    [HOLDER_TYPES.VENDOR]: [
        "vendor_id",
        "id"
    ],

    [HOLDER_TYPES.WAREHOUSE]: [
        "warehouse_id",
        "id"
    ],

    [HOLDER_TYPES.SCRAP]: [
        "id"
    ]

};

/**
 * Possible display name fields
 */
export const HOLDER_NAME_FIELDS = {

    [HOLDER_TYPES.STAFF]: [
        "name",
        "displayName",
        "full_name",
        "employee_name"
    ],

    [HOLDER_TYPES.TECHNICIAN]: [
        "name",
        "displayName",
        "technician_name",
        "employee_name"
    ],

    [HOLDER_TYPES.EMPLOYEE]: [
        "name",
        "displayName",
        "employee_name"
    ],

    [HOLDER_TYPES.STORE]: [
        "store_name",
        "holder_name",
        "name"
    ],

    [HOLDER_TYPES.SITE]: [
        "site_name",
        "project_name",
        "name"
    ],

    [HOLDER_TYPES.CLIENT]: [
        "client_name",
        "name"
    ],

    [HOLDER_TYPES.VENDOR]: [
        "vendor_name",
        "name"
    ],

    [HOLDER_TYPES.WAREHOUSE]: [
        "warehouse_name",
        "name"
    ],

    [HOLDER_TYPES.SCRAP]: [
        "name"
    ]

};